export enum InventoryProductColorType {
  TINTED_COLOR = 'TINTED_COLOR',
  CUSTOM_COLOR = 'CUSTOM_COLOR',
  READY_MIXED_COLOR = 'READY_MIXED_COLOR',
}
